
import "slick-carousel";

$('.image-carousel__slider').slick({
    infinite: true,
    arrows: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: $('.image-carousel-prev'),
    nextArrow: $('.image-carousel-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    adaptiveHeight: true,
});